import Header from "./header1";
import "./ex.css"

export default function Projects() {
  return (
    <div className="excont">
      <Header />
      {/* <Cardlist /> */}
      <p>
        {" "}
        Our company participated in various international exhibitions. One of
        them is Dubai Airshow helded in Dubai, UAE in 2021. Dubai Airshow 2023
        is one of the biggest aerospace events and plays an instrumental role in
        bringing the industry together to access invaluable market insights and
        business opportunities.
      </p>
    </div>
  );
}
